export const EmailCodeTemplates = Object.freeze({
    "MARSH_ERROR":"marsh_error",
    "RACE_ERROR":"race_error",
    "AUTORIZATION":"autorization",
    "MAINTENANCE_DELAY":"maintenance_delay",
    "MAINTENANCE_REJECT": "maintenance_reject",
    "FAILURE_DELAY":"failure_delay",
    "RENTAL":"rental",
    "ITV_DELAY":"itv_delay",
    "LOGISTIC_QUERY":"logistic_query",
    "LOGISTIC_DELAY":"logistic_delay",
    "REPAIRS":"repairs",
    "TYRES_DELAY":"tyres_delay",
    "FEES":"fees",
    "INSURANCES":"insurances",
    "OUT_OF_TIME_SINISTERURANCES":"out_of_time_sinisterurances",
    "APPOINTMENT_CONFIRMATION": "workshop_appointment",
    "WORKSHOP_INFO": "workshop_info",
    "VEHICLE_RETURN_PROTOCOL": "vehicle_return_protocol",
    "OUT_OF_TIME_SINISTER": "out_of_time_sinister_marsh",
    "ITV_APPOINTMENT": "itv_appointment_email"
})

export const EmailTemplates = [
    EmailCodeTemplates.MARSH_ERROR,
    EmailCodeTemplates.RACE_ERROR,
    EmailCodeTemplates.AUTORIZATION,
    EmailCodeTemplates.MAINTENANCE_DELAY,
    EmailCodeTemplates.MAINTENANCE_REJECT,
    EmailCodeTemplates.FAILURE_DELAY,
    EmailCodeTemplates.RENTAL,
    EmailCodeTemplates.ITV_DELAY,
    EmailCodeTemplates.LOGISTIC_QUERY,
    EmailCodeTemplates.LOGISTIC_DELAY,
    EmailCodeTemplates.REPAIRS,
    EmailCodeTemplates.TYRES_DELAY,
    EmailCodeTemplates.FEES,
    EmailCodeTemplates.INSURANCES,
    EmailCodeTemplates.OUT_OF_TIME_SINISTERURANCES,
    EmailCodeTemplates.APPOINTMENT_CONFIRMATION,
    EmailCodeTemplates.VEHICLE_RETURN_PROTOCOL,
    EmailCodeTemplates.WORKSHOP_INFO,
    EmailCodeTemplates.OUT_OF_TIME_SINISTER
]